import { captureMessage } from '@sentry/react';

import { WebViewScope } from 'src/shared/constants/WebViewScope';
import { isMobileApp } from 'src/shared/helpers/environment';

export { WebViewScope };

// enableOnlyForScope allows use to only check if webview is within a specific scope
export const useReactNativeWebView = (
  enableOnlyForScope?: WebViewScope,
): [boolean, (message: string) => void] => {
  const isWebViewResult = isMobileApp(enableOnlyForScope);

  const sendReactNativeMessage = (message: string) => {
    if (isWebViewResult) {
      if (window.ReactNativeWebView?.postMessage) {
        window.ReactNativeWebView.postMessage(message);
      } else {
        captureMessage('ReactNativeWebView: missing postMessage');
      }
    }
  };

  return [isWebViewResult, sendReactNativeMessage];
};
